module.exports = __webpack_public_path__ + "images/category_lp/common/store_images/next_plus_3498aceced13fe9714acbb3daf3cf532.png";